<template>
  <div class="timer-container animated bounceIn">
    <div class="battery-wrap">
      <div v-if="timeup">
        <span>Осталось:</span>
        <span>{{ prettyTime }}</span>
      </div>
      <div v-if="!timeup">Время вышло</div>
<!--      <div class="right">-->
<!--        <span>{{Math.round(percent)}} %</span>-->
<!--        <div class="battery">-->
<!--          <div class="remaining" :class="{'blink': Math.round(percent) <= 10}" :style="{width: Math.round(percent) + '%'}"></div>-->
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'timer',
    data () {
      return {
        time: 60, // в секундах,
        timer: null, // interval
        timeup: true, // время не вышло
        isRunning: false,
        percent: 100,
        step: 1.66 // 100 / time
      }
    },
    methods: {
      setTime (payload) {
        this.time = (payload.minutes * 60 + payload.seconds)
        this.step = 100 / this.time
        this.isRunning = true
        if (!this.timer) {
          this.timer = setInterval(() => {
            if (this.time > 0) {
              this.$store.dispatch('setTime', this.prettyTime)
              this.$store.dispatch('addTimePass')
              this.time--
              this.percent = this.percent - this.step
            } else {
              clearInterval(this.timer)
              this.percent = 0
              this.timeup = false
              // this.sound.play();
              // this.$emit('timeover', false)
            }
          }, 1000)
        }
      },
      clearTimer () {
        this.isRunning = false
        clearInterval(this.timer)
      }
    },
    computed: {
      minutes () {
        return this.$store.getters.test.time
      },
      prettyTime () {
        let time = this.time / 60
        let minutes = parseInt(time)
        let seconds = Math.round((time - minutes) * 60)
        if (minutes < 10) {
          minutes = '0' + minutes
        }
        if (seconds < 10) {
          seconds = '0' + seconds
        }
        return minutes + ':' + seconds
      }
    },
    created () {
      this.setTime({minutes: this.minutes, seconds: 0})
    }

  }
</script>

<style scoped lang="scss">

  .battery-wrap {
    font-size: 12px;
    font-weight: 500;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .right {
      > * {
        display: inline-block;
        vertical-align: middle;
      }
    }
    .battery {
      width: 22px;
      height: 10px;
      border: 1px solid #808080;
      border-radius: 2px;
      box-sizing: content-box;
      padding: 1px 2px;
      position: relative;
      margin-left: 5px;
      .remaining {
        background-color: #000;
        width: 70%;
        height: 100%;
        &.blink {
          animation: blink-bg .7s linear infinite;
        }
      }
      &:after {
        display: block;
        content: '';
        position: absolute;
        right: -4px;
        width: 2px;
        height: 4px;
        border-radius: 0 50% 50% 0;
        background-color: #808080;
        top: 4px;
      }
    }
  }

  @keyframes blink-bg {
    from {
      background-color: #000000;
    }
    to {
      background-color: #e63d37;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/timer/Timer.vue